import React, { useRef } from "react";
import { Layout } from "../components";
import HTMLFlipBook from "react-pageflip";
import "../assets/styles/containers/Magazine.sass";

const Magazine = () => {
  const book = useRef();

  return (
    <div className="Magazine">
      <Layout bannerId={69}>
        <div className="container">
          <div className="Magazine-wraper">
            <HTMLFlipBook
              width={400}
              height={480}
              showCover={true}
              flippingTime={1500}
              ref={book}
            >
              <div className="demoPage">
                <img
                  src="https://legendofeldorado.com/img/revista/1.jpg"
                  alt="La Leyenda Caribe"
                />
              </div>
              <div className="demoPage">
                <img
                  src="https://legendofeldorado.com/img/revista/2.jpg"
                  alt="La Leyenda Caribe"
                />
              </div>
              <div className="demoPage">
                <img
                  src="https://legendofeldorado.com/img/revista/3.jpg"
                  alt="La Leyenda Caribe"
                />
              </div>
              <div className="demoPage">
                <img
                  src="https://legendofeldorado.com/img/revista/4.jpg"
                  alt="La Leyenda Caribe"
                />
              </div>
              <div className="demoPage">
                <img
                  src="https://legendofeldorado.com/img/revista/5.jpg"
                  alt="La Leyenda Caribe"
                />
              </div>
              <div className="demoPage">
                <img
                  src="https://legendofeldorado.com/img/revista/6.jpg"
                  alt="La Leyenda Caribe"
                />
              </div>
              <div className="demoPage">
                <img
                  src="https://legendofeldorado.com/img/revista/7.jpg"
                  alt="La Leyenda Caribe"
                />
              </div>
              <div className="demoPage">
                <img
                  src="https://legendofeldorado.com/img/revista/8.jpg"
                  alt="La Leyenda Caribe"
                />
              </div>
              <div className="demoPage">
                <img
                  src="https://legendofeldorado.com/img/revista/9.jpg"
                  alt="La Leyenda Caribe"
                />
              </div>
              <div className="demoPage">
                <img
                  src="https://legendofeldorado.com/img/revista/10.jpg"
                  alt="La Leyenda Caribe"
                />
              </div>
              <div className="demoPage">
                <img
                  src="https://legendofeldorado.com/img/revista/11.jpg"
                  alt="La Leyenda Caribe"
                />
              </div>
              <div className="demoPage">
                <img
                  src="https://legendofeldorado.com/img/revista/12.jpg"
                  alt="La Leyenda Caribe"
                />
              </div>
              <div className="demoPage">
                <img
                  src="https://legendofeldorado.com/img/revista/13.jpg"
                  alt="La Leyenda Caribe"
                />
              </div>
              <div className="demoPage">
                <img
                  src="https://legendofeldorado.com/img/revista/14.jpg"
                  alt="La Leyenda Caribe"
                />
              </div>
              <div className="demoPage">
                <img
                  src="https://legendofeldorado.com/img/revista/15.jpg"
                  alt="La Leyenda Caribe"
                />
              </div>
              <div className="demoPage">
                <img
                  src="https://legendofeldorado.com/img/revista/16.jpg"
                  alt="La Leyenda Caribe"
                />
              </div>
              <div className="demoPage">
                <img
                  src="https://legendofeldorado.com/img/revista/17.jpg"
                  alt="La Leyenda Caribe"
                />
              </div>
              <div className="demoPage">
                <img
                  src="https://legendofeldorado.com/img/revista/18.jpg"
                  alt="La Leyenda Caribe"
                />
              </div>
            </HTMLFlipBook>
          </div>
          <div className="Magazine-buttons">
            <button onClick={() => book.current.pageFlip().flipPrev()}>
              {"<"}
            </button>

            <button onClick={() => book.current.pageFlip().flipNext()}>
              {">"}
            </button>
          </div>
        </div>
      </Layout>
    </div>
  );
};

export default Magazine;
